<div class="content-padding">
    <div class="wordpress" [innerHTML]="page?.content?.rendered"></div>
    <div *ngIf="!page?.content?.rendered" class="input-error">ERROR: No WP content</div>
</div>
